import { render, staticRenderFns } from "./SalesByMonth.vue?vue&type=template&id=01af401b&"
import script from "./SalesByMonth.vue?vue&type=script&lang=js&"
export * from "./SalesByMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports